import { render, staticRenderFns } from "./ChatSystemContent.vue?vue&type=template&id=6f83fa8e"
import script from "./ChatSystemContent.vue?vue&type=script&lang=js"
export * from "./ChatSystemContent.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemContent.vue?vue&type=style&index=0&id=6f83fa8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports